var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.624 5.878a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0M8.9 9.7A4.874 4.874 0 0 1 1 5.877a4.874 4.874 0 0 1 4.874-4.874 4.874 4.874 0 0 1 3.823 7.9l3.138 3.139a.562.562 0 0 1-.795.794z"
  })));
};
export default SvgSearch;